import { VideoStatus } from '../enums';
import { Event } from '../interfaces';

export const isEventVideoRemoved = (event: Event): boolean => {
  return event.event_videos?.[0]?.status === VideoStatus.removed;
};
